import AssessmentPromptField, {
  ASSESSMENT_PROMPT_MAX_LENGTH,
} from "../TaggingPlan/AssessmentPromptField";
import { useOtoDefaultPrompt } from "../../../hooks/useOtoDefaultPrompt";
import { isOtoInsightToDocsPair } from "./otoDefaultPromptPair";

type OtoPromptFieldWithDefaultProps = Readonly<{
  referenceObjectType: string;
  impactedObjectType: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  maxLength?: number;
  label?: string;
  required?: boolean;
  disabled?: boolean;
}>;

export default function OtoPromptFieldWithDefault({
  referenceObjectType,
  impactedObjectType,
  value,
  onChange,
  error = false,
  helperText,
  maxLength = ASSESSMENT_PROMPT_MAX_LENGTH,
  label = "Prompt",
  required = false,
  disabled = false,
}: OtoPromptFieldWithDefaultProps) {
  const fetchEnabled =
    !disabled &&
    isOtoInsightToDocsPair(referenceObjectType, impactedObjectType);

  const { defaultPrompt, loading } = useOtoDefaultPrompt({
    referenceObjectType,
    impactedObjectType,
    enabled: fetchEnabled,
  });

  return (
    <AssessmentPromptField
      value={value}
      suggestedPrompt={defaultPrompt}
      suggestedPromptLoading={loading}
      onChange={onChange}
      error={error}
      helperText={helperText}
      maxLength={maxLength}
      label={label}
      required={required}
      showDefaultPromptInfo
      disabled={disabled}
    />
  );
}
